import { Injectable } from "@angular/core";
import { AppHttpClient } from "src/app/modules/shared/services/http-client.service";
import { AppUrlsService } from "src/app/modules/shared/services/app-urls.service";
@Injectable()
export class SidebarService {
  private domain = `${this.appUrlsService.CORE_LINK}`;

  private urls = {
    productModulesUr: `${this.domain}/api/v2/product-module`,
  };

  constructor(
    private http: AppHttpClient,
    private appUrlsService: AppUrlsService
  ) {}
 
  getAllSideMenus(){
      return this.http.get(this.urls.productModulesUr);
  }
}
